"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n\n  border-radius: inherit;\n\n  cursor: pointer;\n  background-color: var(--color-grey-dark-1);\n  opacity: 0;\n  transition: opacity 0.3s;\n\n  &:hover {\n    opacity: 0.5;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  & [data-meta='variable-parsed-paragraph'] {\n    ", "\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  & [data-meta='variable-parsed-paragraph'] {\n    ", "\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 0 0 0.375em 0.375em;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  border-radius: 0.375em 0.375em 0 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  overflow: unset;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  transition: background-color 0.3s;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.1);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var image_explanation_option_view_styles_1 = require("../image-explanation-option-view/image-explanation-option-view.styles");

var styled_components_1 = __importStar(require("styled-components"));

var editableHoverBGcolorStyle = styled_components_1.css(_templateObject());
exports.StyledEditableImageExpOptionWrapperDiv = styled_components_1.default(image_explanation_option_view_styles_1.StyledImageExpOptionWrapperDiv)(_templateObject2());
exports.StyledEditableImageExpOptionImageDiv = styled_components_1.default(image_explanation_option_view_styles_1.StyledImageExpOptionImageDiv)(_templateObject3());
exports.StyledEditableImageExpOptionBodyDiv = styled_components_1.default(image_explanation_option_view_styles_1.StyledImageExpOptionBodyDiv)(_templateObject4());
exports.StyledEditableImageNameH2 = styled_components_1.default(image_explanation_option_view_styles_1.StyledImageNameH2)(_templateObject5(), editableHoverBGcolorStyle);
exports.StyledEditableExplanationParagraph = styled_components_1.default(image_explanation_option_view_styles_1.StyledExplanationDiv)(_templateObject6(), editableHoverBGcolorStyle);
exports.StyleOverlayDiv = styled_components_1.default.div(_templateObject7());